// extracted by mini-css-extract-plugin
module.exports = {"Body":"WarningModal_Body__3EwBZ","Footer":"WarningModal_Footer__3RQVm","Live":"WarningModal_Live__2TiRY","Button":"WarningModal_Button__DTLt_"};